<ng-template #draftButtonsSection>
  @if ((!isDraft && selectedInvestment) || (isDraft && selectedInvestmentExtended)) {
    @if (!isDraft && selectedInvestment) {
      <div class="summary-btn">
        <libero-button
          label="{{ 'summary.addMoney' | translate }}"
          btnClasses="btn--primary btn--heading"
          (click)="openMoneyModal()"
        ></libero-button>
        <libero-button
          label="{{ 'global.buttons.edit' | translate }} {{ (selectedInvestment.portfolioType === 'STRATEGY' ? 'global.buttons.strategy' : 'global.buttons.portfolio') | translate }}"
          btnClasses="btn--secondary btn--card-action"
          svgIcon="pencil"
          [iconWidth]="16"
          [routerLink]="[selectedInvestment.portfolioType === 'STRATEGY' ?  '/strategy/edit/' + selectedInvestment.portfolioId : '/portfolio/edit/' + selectedInvestment.portfolioId, { origin: 'detail'}]"
          [attr.data-cy]="'owned-card-edit-button-' + selectedInvestment.portfolioType"
          [preloader]="preloaders.strategyPartialAccess"
          (click)="loadStrategyEditForPMWithStrategies()"
          [preloaderInverse]="false"
          [smallSecondary]="true"
        ></libero-button>
        <libero-button
          label="{{ 'global.buttons.delete' | translate }} {{ (selectedInvestment.portfolioType === 'STRATEGY' ? 'global.buttons.strategy' : 'global.buttons.portfolio') | translate }}"
          btnClasses="btn--secondary btn--card-action"
          svgIcon="trash"
          [iconWidth]="16"
          [buttonDisabled]="!selectedInvestmentExtended.canRemovePortfolio"
          (click)="selectedInvestmentExtended.canRemovePortfolio && deleteInvestment()"
          [attr.data-cy]="'owned-card-delete-button-' + selectedInvestment.portfolioType"
          [disabledTooltipText]="!selectedInvestmentExtended.canRemovePortfolio ? (selectedInvestment.portfolioType === 'STRATEGY' ? 'notDeletableStrategy' : 'notDeletablePortfolio') : null"
        ></libero-button>
        <div
          class="fees-action"
          (click)="openFeesModal()"
          data-cy="fees-config-modal-btn"
          (keydown.space)="openFeesModal()"
          (keydown.enter)="openFeesModal()"
          tabindex="0"
          >
          {{ 'consultClientDetail.feesInfo' | translate }}
        </div>
      </div>
    } @else {
      <div class="summary-btn">
        @if (!selectedInvestmentExtended.aml) {
          <libero-button
            label="{{ 'global.buttons.updateAml' | translate }}"
            btnClasses="btn--secondary btn--heading btn--draft btn--danger-border"
            (click)="goToAMLForm()"
            data-cy="draft-update-aml-btn"
          ></libero-button>
        }
        @if (selectedInvestmentExtended.aml) {
          <libero-button
            label="{{ 'global.buttons.acceptDraft' | translate }}"
            btnClasses="btn--primary btn--heading btn--draft"
            (click)="openDraftAcceptRefuseConfirm(selectedInvestmentExtended, 'accept')"
            data-cy="draft-accept-btn"
            [buttonDisabled]="!selectedInvestmentExtended.canAcceptDraft"
            disabledTooltipText="instrumentsNotAllowedForDraftAccept"
          ></libero-button>
        }
        <libero-button
          label="{{ 'global.buttons.refuseDraft' | translate }}"
          btnClasses="btn--danger btn--heading btn--draft"
          (click)="openDraftAcceptRefuseConfirm(selectedInvestmentExtended, 'refuse')"
          data-cy="draft-refuse-btn"
        ></libero-button>
      </div>
    }
  }
</ng-template>

<div class="detail-container">
  @if (isDraft) {
    <div class="draft-bg" data-cy="draft-detail-bg"></div>
  }
  <div class="summary-layout" [ngClass]="{'draft': isDraft}">
    <div class="summary" data-cy="summary">
      <div class="desktop-summary-layout">
        @if (isDraft && selectedInvestmentExtended) {
          <div class="draft-expiration-panel">
            <div class="draft-expiration" data-cy="draft-expiration-text">
              <svg-icon src="assets/icons/clock.svg" [svgStyle]="{ 'width.px':22, 'height.px':22, 'transform': 'translateY(-2px)' }"></svg-icon>
              <span class="ml-2">
                {{ 'strategyCard.draftCardFooter.common1' | translate }}
                {{ (selectedInvestmentExtended.portfolioType === 'STRATEGY' ? 'strategyCard.draftCardFooter.strategy' : 'strategyCard.draftCardFooter.portfolio') | translate }}
                {{ 'strategyCard.draftCardFooter.common2' | translate }}
              </span>
              <span class="text-success">
                {{ selectedInvestmentExtended.autoExpiryTime | dayDiff }}
              </span>
            </div>
          </div>
        }

        @if (!isDraft && selectedInvestment) {
          <div class="selected-investment-slider-container">
            <div
              class="arrow-container"
              [ngClass]="{'arrow-container--disabled': !slidePrevExist() }"
              (click)="slideSelected(slideDirections.PREV)"
              (keydown.space)="slidePrevExist() && slideSelected(slideDirections.PREV)"
              (keydown.enter)="slidePrevExist() && slideSelected(slideDirections.PREV)"
              tabindex="0"
              >
              <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(90deg)' }"></svg-icon>
            </div>
            <div class="name-container">
              @if (selectedInvestment.dip) {
                <p class="dip-stamp-text">{{ 'global.dipShortcut' | translate }}</p>
              }
              <div class="selected-type">
                @if (selectedInvestment.portfolioType === 'STRATEGY') {
                  {{  'money.strategy' | translate }}
                } @else {
                  {{  'money.portfolio' | translate }}
                }
              </div>
              <div class="select-name-container">
                <div class="selected-name">
                  {{ selectedInvestment.name }}
                </div>
              </div>
            </div>
            <div
              class="arrow-container"
              [ngClass]="{'arrow-container--disabled': !slideNextExist() }"
              (click)="slideSelected(slideDirections.NEXT)"
              (keydown.space)="slideNextExist() && slideSelected(slideDirections.NEXT)"
              (keydown.enter)="slideNextExist() && slideSelected(slideDirections.NEXT)"
              tabindex="0"
              >
              <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(270deg)' }"></svg-icon>
            </div>
          </div>
        }

        @if (isDraft && selectedInvestmentExtended) {
          <div class="selected-investment-slider-container">
            <div class="name-container" data-cy="draft-name-container">
              @if (selectedInvestmentExtended.dip) {
                <p
                  class="dip-stamp-text"
                  data-cy="draft-dip-text"
                >{{ 'global.dipShortcut' | translate }}</p>
              }
              <div class="selected-type">
                {{  'money.draftLabel' | translate }}
                @if (selectedInvestmentExtended.portfolioType === 'STRATEGY') {
                  {{  'money.strategyGen' | translate }}
                } @else {
                  {{  'money.portfolioGen' | translate }}
                }
              </div>
              <div class="select-name-container">
                <div class="selected-name">
                  {{ selectedInvestmentExtended.name }}
                </div>
              </div>
            </div>
          </div>
        }

        @if (!preloaders.initData && !preloaders.selectedInvestment) {
          @if ((!isDraft && selectedInvestment) || (isDraft && selectedInvestmentExtended)) {
            <div class="desktop-sum-layout">
              @if (!isDraft) {
                <div class="summary-label">
                  <div class="label label--tooltiped">
                    {{ 'summary.value' | translate }}
                    <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                      {{ 'global.tooltips.value' | translate }}
                    </libero-tooltip-button>
                  </div>
                  <div class="value"  data-cy="detail-value">
                    {{ selectedInvestmentExtended.sumAmount | price:loggedUser.currencyCode }}
                  </div>
                </div>
              }
              @if (!isDraft) {
                <div class="summary-label draft-order-4">
                  <div class="label label--tooltiped">
                    {{ 'summary.yield' | translate }}
                    <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                      {{ 'global.tooltips.yield' | translate }}
                    </libero-tooltip-button>
                  </div>
                  <div class="value value--yield " [ngClass]="{ 'value--yield-positive': positiveYield }" data-cy="detail-yield">
                    {{ positiveYield ? '+' : '' }} {{ selectedInvestmentExtended.actualYield| price:loggedUser.currencyCode }}
                  </div>
                </div>
              }
              <div class="summary-label draft-order-1">
                <div class="label label--tooltiped">
                  {{ 'summary.investmentPeriod' | translate }}
                  <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                    {{ 'global.tooltips.totalYearsToInvest' | translate }}
                  </libero-tooltip-button>
                </div>
                <div class="value" data-cy="detail-totalYearsToInvest">
                  {{ selectedInvestmentExtended.totalYearsToInvest | currencyDigitShortcut: yearsShortcutsOptions }}
                </div>
              </div>
              <div class="summary-label draft-order-3">
                <div class="label label--tooltiped">
                  {{ 'summary.initialDeposit' | translate }}
                  <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                    {{ 'global.tooltips.initialDeposit' | translate }}
                  </libero-tooltip-button>
                </div>
                <div class="value" data-cy="detail-initialDeposit">
                  {{ selectedInvestmentExtended.initialDeposit | price:loggedUser.currencyCode }}
                </div>
              </div>
              <div class="summary-label draft-order-2">
                <div class="label label--tooltiped">
                  {{ 'summary.regularDeposit' | translate }}
                  <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                    {{ 'global.tooltips.regularDeposit' | translate }}
                  </libero-tooltip-button>
                </div>
                <div class="value" data-cy="detail-regularInvestment">
                  {{ selectedInvestmentExtended.regularDeposit | price:loggedUser.currencyCode }}
                </div>
              </div>
              @if (!isDraft) {
                <div class="summary-label">
                  <div class="label label--tooltiped">
                    {{ 'summary.investmentFrequency' | translate }}
                    <libero-tooltip-button [explainPerson]="'jiri_sindelar'">
                      {{ 'global.tooltips.investmentFrequency' | translate }}
                    </libero-tooltip-button>
                  </div>
                  <div class="value" data-cy="detail-investmentFrequency">
                    {{ selectedInvestmentExtended.weeksBetweenInvestments | investmentFrequency | translate }}
                  </div>
                </div>
              }
            </div>
          } @else {
            {{ 'global.error.loadData' | translate }}
          }
        } @else {
          <libero-preload-spinner></libero-preload-spinner>
        }
        <ng-container [ngTemplateOutlet]="draftButtonsSection"></ng-container>

      </div>
    </div>
  </div>

  @if (!isDraft) {
    <div class="charts-container">
      <div class="charts-layout">
        @if (!preloaders.chart) {
          <div class="chart-container">
            @if (!errors.chart) {
              @if (chartLabels.length > 0 || chartValues.length > 0) {
                <libero-charts
                  [chartData]="chartValues"
                  [xLabels]="chartLabels"
                  [deposits]="deposits"
                  [depositsLinePoints]="depositsLinePoints"
                  [showDeposits]="chartForm.controls['showDepositsOnChart'].value"
                  [userLocalization]="loggedUser.currencyCode"
                  [isPercent]="isTwrSelected()"
                ></libero-charts>
              } @else {
                <div class="api-error-container">
                  {{ 'global.error.noChartData' | translate }}
                </div>
              }
            } @else {
              <div class="api-error-container">
                {{ 'global.error.loadData' | translate }}
              </div>
            }
          </div>
        } @else {
          <div class="prealoader-container">
            <libero-preload-spinner></libero-preload-spinner>
          </div>
        }
        <div class="container-fluid chart-filters">
          <div class="row pt-1 pt-md-4">
            <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
              <div class="row">
                <div class="col-4 col-md-12 filtration-label">
                  {{ 'summary.period' | translate }}
                </div>
                <div class="col-8 col-sm-7 col-md-12">
                  <libero-dropdown
                    [itemSelectedControl]="chartForm.controls['period']"
                    [availableList]="filtrablePeriods"
                    [displaySelectAllOption]="false"
                    [initialValue]="filtrablePeriods[0]"
                  ></libero-dropdown>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
              <div class="row">
                <div class="col-4 col-md-12 filtration-label filtration-label--tooltiped">
                  <div class="phone-content">
                    <libero-tooltip-button [explainPerson]="'monika_skodova'">
                      {{ 'global.tooltips.percentualInvestmentDevelopment' | translate }}
                    </libero-tooltip-button>
                  </div>
                  {{ loggedUser.currencyCode }}/%
                  <div class="desktop-content">
                    <libero-tooltip-button [explainPerson]="'monika_skodova'">
                      {{ 'global.tooltips.percentualInvestmentDevelopment' | translate }}
                    </libero-tooltip-button>
                  </div>
                </div>
                <div class="col-8 col-sm-7 col-md-12">
                  <libero-dropdown
                    [itemSelectedControl]="chartForm.controls['priceMeasure']"
                    [availableList]="currencyFilter"
                    [displaySelectAllOption]="false"
                    [initialValue]="currencyFilter[0]"
                  ></libero-dropdown>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3 pt-3 pt-md-0 col-xl-2">
              <div class="row">
                <div class="col-4 col-md-12 filtration-label">
                  {{ 'summary.showDeposits' | translate }}
                </div>
                <div class="col-8 col-sm-7 col-md-12 switch-align">
                  <libero-toggle-switch
                    [formName]="chartForm.controls['showDepositsOnChart']"
                    [disabled]="isTwrSelected()"
                  ></libero-toggle-switch>
                </div>
              </div>
            </div>
            <div class="col-12 mt-5 col-md-12 mt-xl-0 offset-xl-1 col-xl-3 desktop-buttons-align">
              <div class="buttons-container">
                <libero-button label="{{ 'global.buttons.consultation' | translate }}" (click)="openConsultModal()" btnClasses="btn--icon-text icon--secondary" svgIcon="accountant"></libero-button>
                <libero-button label="{{ 'global.buttons.videos' | translate }}" btnClasses="btn--icon-text" svgIcon="white-play-on-secondary-text" routerLink="/videos"></libero-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!isDraft) {
    <div class="rounded-corner-bg rounded-corner-bg--reversed">
      <div class="rounded-corner rounded-corner--reversed"></div>
    </div>
  }

  <div class="container-fluid g-0 content-background" [ngClass]="{'draft': isDraft}">
    @if ((!isDraft && selectedInvestment && !preloaders.initData && !preloaders.selectedInvestment) || (isDraft && selectedInvestmentExtended)) {
      <div class="row g-0 desktop-padding">
        @if (isDraft) {
          <div class="col-12">
            <div class="consultant-commentary-container">
              <libero-button
                label="{{ 'global.buttons.consultantComment' | translate }}"
                btnClasses="btn--secondary btn--heading btn--draft draft-consultant-commentary-header"
              ></libero-button>
              <libero-draft-commentary
                [consultCommentary]="draftCommentary"
              ></libero-draft-commentary>
            </div>
          </div>
        }
        <div class="col-12 col-md-5 col-xl-4">
          <div class="description-header">
            {{ (selectedInvestmentExtended.portfolioType === "PORTFOLIO" ? 'newPortfolio.portfolioContent' : 'newPortfolio.strategyContent') | translate }}
          </div>
          <div class="description-toggler-container">
            <libero-description-dropdown [riskScore]="selectedInvestmentExtended.riskScore"></libero-description-dropdown>
          </div>
          <div class="instrument-cards-container">
            <libero-instrument-chart-carousel
              [instrumentChart]="instrumentChart"
              [userLocalization]="loggedUser.language"
            ></libero-instrument-chart-carousel>
          </div>
        </div>
        <div class="col-12 col-md-7 col-xl-8 draft-middle-bg">
          <div class="detailed-breakdown">
            <div class="breakdown-heading">
              {{ 'newPortfolio.detailedBreakdown' | translate }}
            </div>
            <div class="breakdown-table-header">
              <div class="heading">
                {{ 'newPortfolio.selectedInvestmentTools' | translate }}
              </div>
              <div class="heading heading--desktop heading--center heading--capitalize-all" style="padding-left: 25px;">
                {{ 'newPortfolio.goal' | translate }}
              </div>
              <div class="heading heading--desktop heading--right">
                {{ 'newPortfolio.value' | translate }}
              </div>
            </div>
            @if (instrumentChart) {
              <div class="list-container" data-cy="list-container">
                <libero-dropdown-list
                  [listData]="instrumentChart.chartData"
                  [instrumentsRatios]="selectedInvestmentInstrumentsRatios"
                ></libero-dropdown-list>
                @if (isDraft) {
                  <ng-container [ngTemplateOutlet]="draftButtonsSection"></ng-container>
                }
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <libero-preload-spinner></libero-preload-spinner>
    }
  </div>

  @if (!isDraft && loggedUser.managementType === 'EXECUTION_ONLY') {
    <div class="thematic-strategies-container">
      <div class="thematic-strategies-layout">
        <div class="thematic-strategies">
          @if (!preloaders.modelStrategies) {
            <div class="swiper-container">
              <libero-model-strategy-carousel [modelStrategies]="modelStrategies!"></libero-model-strategy-carousel>
            </div>
          } @else {
            <libero-preload-spinner></libero-preload-spinner>
          }
        </div>
      </div>
    </div>
  }
</div>
